import React, { Fragment, useContext } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Fab } from "@material-ui/core";
import { workFuncList } from "../../constant/equip-options";
import { DesignContext } from "../../context/design";
import { LangContext } from "../../context/lang";

const useStyle = makeStyles((theme: Theme) => ({
  workFunction: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
  },
}));

const EquipDesignWorkfunction = () => {
  const classes = useStyle();
  const { lang } = useContext(LangContext);
  const { map, event, setevent } = useContext(DesignContext);
  const { feature } = event;

  const _changeWorkFunc = (workFunc: string) => () => {
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    setevent({
      ...event,
      feature: {
        ...event.feature,
        properties: { ...event.feature?.properties, workFunc: workFunc },
      },
    });
    if (feature) {
      draw.setFeatureProperty(feature.id, "workFunc", workFunc);
    }
  };
  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="subtitle1">{lang.data.workFunction}</Typography>
      </Grid>
      <Grid item xs={12} className={classes.workFunction}>
        {workFuncList.map((wf) => (
          <Fab
            key={wf.value}
            variant="round"
            size="small"
            color={
              feature?.properties?.workFunc === wf.value ? "primary" : "default"
            }
            onClick={_changeWorkFunc(wf.value)}
          >
            {wf.label}
          </Fab>
        ))}
      </Grid>
    </Fragment>
  );
};

export default EquipDesignWorkfunction;
